import invoiceItems from "./invoiceItems.component";
import invoiceItemsUrls from "./invoiceItems.urls";
import InvoiceItemsTransforms from "./invoiceItems.transforms";

const invoiceItemsModule = angular
  .module("app.components.invoiceItems", [])
  .component("invoiceItemsPage", invoiceItems)
  .service("InvoiceItemsTransforms", InvoiceItemsTransforms)
  .config(invoiceItemsUrls);

export default invoiceItemsModule;



// WEBPACK FOOTER //
// ./src/pages/invoiceItems/invoiceItems.module.js